if (jQuery('.carousel').length) {
  //Image Gallery functionality
  var ele_h3 = document.querySelector('main .carousel-item.active h3');
  var ele_span = document.querySelector('main .direction-nav span');
  var sPosition = getCoords(ele_span).top;
  var dPosition = getCoords(ele_h3).top - sPosition;
  var checkMobile = function () {
      if (window.innerWidth < 500 && dPosition != undefined) {
          document.querySelector('.carousel-control-prev').setAttribute('style', "top:" + dPosition + "px");
          document.querySelector('.carousel-control-next').setAttribute('style', "top:" + dPosition + "px");
      }
  };
  // Carousel Pauses when window size is less than 379px
  jQuery(function() {
    checkMobile();
    /* Initialize Carousel */
    var paused = 0;
      jQuery('.carousel').carousel({
        pause: true,
        interval: 0
      });
      checkMobile();
    // }
    /* Play trigger */
    jQuery('#pauseButton').click(function() {
      var state = paused ? 'cycle' : 'pause';
      paused = paused ? 0 : 1;
      jQuery('.carousel').carousel(state);
      jQuery(this)
        .find('i')
        .toggleClass('fa-play fa-pause');
      // Compare pause states
      if (paused == 0) {
        jQuery('#pauseButton span').html('Pause');
      } else {
        jQuery('#pauseButton span').html('Play');
      }
    });
  });

  // Slide counter for Image Gallery
  var totalItems = jQuery('.item').length;
  var currentIndex = jQuery('div.active').index() + 1;
  jQuery('.num').html(''+currentIndex+'/'+totalItems+'');
  jQuery('.image-gallery').on('slid.bs.carousel', function() {
    currentIndex = jQuery('div.active').index() + 1;
    jQuery('.num').html(''+currentIndex+'/'+totalItems+'');
  });

  // Mobile Get position of h3 and move prev/next icons
  var ele_h3 = document.querySelector('main .carousel-item.active h3');
  var ele_span = document.querySelector('main .direction-nav span');
  function getCoords(elem) {
    // crossbrowser version
    if (elem != null) {
      var box = elem.getBoundingClientRect();
      var body = document.body;
      var docEl = document.documentElement;
      var scrollTop = window.pageYOffset || docEl.scrollTop || body.scrollTop;
      var scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;
      var clientTop = docEl.clientTop || body.clientTop || 0;
      var clientLeft = docEl.clientLeft || body.clientLeft || 0;
      var top = box.top + scrollTop - clientTop;
      var left = box.left + scrollLeft - clientLeft;
      return { top: Math.round(top), left: Math.round(left) };
    } else {
      return false;
    }
  }
  var sPosition = getCoords(ele_span).top;
  var dPosition = getCoords(ele_h3).top - sPosition;
  var checkMobile = function () {
    if (window.innerWidth < 500 && dPosition != undefined) {
      document.querySelector('.carousel-control-prev').setAttribute('style', "top:" + dPosition + "px");
      document.querySelector('.carousel-control-next').setAttribute('style', "top:" + dPosition + "px");
    }
  };
  jQuery('#dolFrontPageCarousel').on('slide.bs.carousel', function () {
    checkMobile();
  });
  jQuery('#dolFrontPageCarousel').on('slid.bs.carousel', function () {
    checkMobile();
  });

  (function ($) {
      Drupal.behaviors.myBehavior = {
          attach: function (context, settings)
          {
              $( document ).ready(function() {
                if($(".notoolbar-buttons").length) {
                    $("#top-agency-name .search").addClass("push-right");
                }
              });
          }
      };
  })(jQuery);
};